// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { styled } from '@material-ui/core';

/** @deprecated Use HeaderContentBui instead. */
export const HeaderContent = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  marginLeft: 'auto',
}));
